// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  projectId: __t.u64().name("project_id"),
  liveReleaseId: __t.u64().name("live_release_id"),
  loadedReleaseId: __t.u64().name("loaded_release_id"),
  runtimeVerified: __t.bool().name("runtime_verified"),
  fidelityTier: __t.u8().name("fidelity_tier"),
  capManifest: __t.string().name("cap_manifest"),
  updatedAt: __t.timestamp().name("updated_at"),
});
